import './products-slider.component.scss'

import { Swiper, Navigation, Keyboard, Scrollbar, Mousewheel } from 'swiper'
Swiper.use(Navigation)
Swiper.use(Keyboard)
Swiper.use(Scrollbar)
Swiper.use(Mousewheel)
import { breakpoints } from '../../application/utils/breakpoints'
import { createRecently } from './recently'

export function createSwiper(root, swiperElement) {
  const isDifferent = root.classList.contains('products-slider--different')
  let payload = {}
  if (isDifferent) {
    payload = {
      ...payload,
      scrollbar: {
        el: root.querySelector('.swiper-scrollbar'),
        draggable: true
      }
    }
  }
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      prevEl: swiperElement
        .closest('section')
        .querySelector('.swiper-buttons button[data-prev]'),
      nextEl: swiperElement
        .closest('section')
        .querySelector('.swiper-buttons button[data-next]')
    },
    breakpoints: {
      [breakpoints.small + 1]: {
        slidesPerView: isDifferent ? 'auto' : 3,
        spaceBetween: isDifferent ? 35 : 10
      },
      [breakpoints.smallest + 1]: {
        slidesPerView: 2
      }
    },
    ...payload
  })
}

document.querySelectorAll('.products-slider').forEach(async (root) => {
  if (root.classList.contains('products-slider--recently')) {
    const handles = localStorage.rv ? JSON.parse(localStorage.rv) : null
    if (handles && handles.length > 0) {
      await createRecently(root, handles)
      if(root.querySelector('.swiper-container')) createSwiper(root, root.querySelector('.swiper-container'))
    } else {
      root.remove()
    }
  } else {
    if(root.querySelector('.swiper-container')) createSwiper(root, root.querySelector('.swiper-container'))
  }
})
